import { render, staticRenderFns } from "./LocalizationStatusDot.vue?vue&type=template&id=0b70d7ba&"
import script from "./LocalizationStatusDot.vue?vue&type=script&lang=js&"
export * from "./LocalizationStatusDot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports